import s from "./content.module.css";
import {iconCloseV2, storeLocationIcon, storePhoneIcon} from "../../../../../assets";
import InfoBlock from "./InfoBlock";
import {blockIcon} from "./content.helper";
import {useAppContext} from "../../../../../contexts";

const Content = (props) => {
    // Destructured props
    const {
        storeName,
        data,
        setIsOpen
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Renders nothing if no data exists
    if (Object.keys(data).length === 0) {
        return null;
    }

    // Work hours
    const workTime =
        data.opening_hours.map(item => {
            return (
                <InfoBlock
                    key={item.id}
                    icon={blockIcon(item.name)}
                    title={`${item.name}:`}
                    value={item.value}
                />
            )
        });

    return (
        <div className={`${s.root}`}>
            {/* Header block */}
            <div className={"w-full flex justify-between items-center"}>
                <h1 className={`font-museo ${s.storeName} ${highContrast ? s.dmHeadingTitle : ""}`}>
                    {storeName}
                </h1>
                <button
                    type={"button"}
                    className={`${s.closeButton} ${highContrast ? "!text-white" : ""}`}
                    onClick={() => setIsOpen(false)}
                >
                    Fechar
                    <img
                        src={iconCloseV2}
                        alt="Close icon"
                        className={`${highContrast ? "!bg-[#fecc31]" : ""}`}
                    />
                </button>
            </div>

            {/* Content block */}
            <div className={`font-museo flex flex-col md:flex-row gap-y-4 gap-x-8 w-full justify-between`}>
                <div className={`rounded p-5 w-full flex flex-col gap-y-4 ${highContrast ? "border border-[#666]" : "bg-light-gray"}`}>
                    <InfoBlock
                        icon={storeLocationIcon}
                        title={"Endereço:"}
                    >
                        {data.address_street} - {data.address_neighborhood} - {data.city.name} - {data.city.state.name},
                        <br />
                        CEP: {data.address_postal_code}
                    </InfoBlock>
                    <InfoBlock
                        icon={storePhoneIcon}
                        title={"Telefone:"}
                    >
                        {data.phone_number}
                    </InfoBlock>
                </div>

                <div className={`rounded p-5 w-full flex-col gap-y-4 ${data.opening_hours.length < 1 ? "hidden" : "flex"} ${highContrast ? "border border-[#666]" : "bg-light-gray"}`}>
                    {workTime}
                </div>
            </div>
        </div>
    )
}

export default Content;
